"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[999,2840],{

/***/ 4152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BookingCalendar_DialogBase; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ./providers/BookingCalendar/types.ts
var types = __webpack_require__(8837);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ./components/profiles/ProfileModal/ProfileModalLayout.tsx
var ProfileModalLayout = __webpack_require__(6904);
// EXTERNAL MODULE: ./components/Header/index.tsx + 11 modules
var Header = __webpack_require__(77188);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/CloseRounded/index.esm.js
var index_esm = __webpack_require__(2555);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Dialog/Dialog.esm.js + 2 modules
var Dialog_esm = __webpack_require__(30280);
;// CONCATENATED MODULE: ./components/BookingCalendar/DialogBase/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var StyledCloseIcon = (0,styled_esm/* default */.ZP)(index_esm/* CloseRoundedIcon */.v)(function() {
    return {
        color: "#6F7F9E",
        cursor: "pointer",
        borderRadius: "50%",
        width: "34px",
        height: "34px",
        padding: "4px",
        boxShadow: "0px 0px 7px 0px rgba(0, 0, 0, 0.10)"
    };
});
var StyledContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        width: "100%",
        paddingTop: "82px",
        paddingInline: "16px",
        overflowX: "hidden"
    }, theme.breakpoints.down("sm"), {
        paddingTop: "22px"
    });
});
var FullScreenDialog = (0,styled_esm/* default */.ZP)(Dialog_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        display: "flex",
        flexDirection: "column",
        "& .MuiDialog-container": {
            width: "100%"
        }
    }, theme.breakpoints.down("sm"), {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        "& .MuiDialog-paper": {
            width: "100%",
            maxHeight: "none",
            borderRadius: "16px 16px 0px 0px",
            bottom: 0,
            left: 0,
            marginTop: "5vh !important",
            height: "95vh !important"
        },
        "& .MuiDialogContent-root": {
            width: "100%",
            padding: "24px 8px 24px 24px",
            overflow: "hidden"
        }
    });
});

// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
// EXTERNAL MODULE: ./components/ProviderHeader/index.tsx + 1 modules
var ProviderHeader = __webpack_require__(37798);
// EXTERNAL MODULE: ./components/ClaimYourProfile/types.ts
var ClaimYourProfile_types = __webpack_require__(66197);
;// CONCATENATED MODULE: ./components/BookingCalendar/DialogBase/index.tsx
function DialogBase_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DialogBase_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var CloseSection = function(param) {
    var sx = param.sx, onReturnBackClick = param.onReturnBackClick, onClose = param.onClose;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
        sx: _objectSpread({
            position: onReturnBackClick ? "initial" : "absolute",
            right: "32px",
            top: "20px",
            zIndex: 1
        }, sx || {}),
        children: onReturnBackClick ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
            display: "flex",
            position: "relative",
            justifyContent: "space-between",
            alignItems: "center",
            p: "20px 20px 10px 20px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    color: "#3C4659",
                    onClick: onReturnBackClick,
                    sx: {
                        cursor: "pointer",
                        textDecoration: "underline"
                    },
                    children: translate("back")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseIcon, {
                    onClick: onClose
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseIcon, {
            onClick: onClose
        })
    });
};
var DialogBase = function(_param) {
    var children = _param.children, variant = _param.variant, onReturnBackClick = _param.onReturnBackClick, props = _objectWithoutProperties(_param, [
        "children",
        "variant",
        "onReturnBackClick"
    ]);
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    if (variant === types/* MODAL_VARIANTS.FULL_SCREEN */.R.FULL_SCREEN) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullScreenDialog, _objectSpread({
            fullScreen: true
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseSection, {
                    sx: {
                        display: {
                            xs: "flex",
                            sm: "none"
                        }
                    },
                    onReturnBackClick: onReturnBackClick,
                    onClose: props.onClose
                }),
                isWPA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderHeader/* default */.Z, {
                    variant: ClaimYourProfile_types/* PROVIDERS_VARIANTS.WPA */.l.WPA,
                    shouldReverse: true,
                    logoAlign: "flex-end"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    sx: {
                        display: {
                            xs: "none",
                            sm: "flex"
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        width: "100%",
                        maxWidth: "1040px",
                        children: children
                    })
                })
            ]
        }));
    }
    if (variant === types/* MODAL_VARIANTS.SIDE_MODAL */.R.SIDE_MODAL) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileModalLayout/* StyledDialog */.I2, _objectSpread({}, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseSection, {
                    onReturnBackClick: onReturnBackClick,
                    onClose: props.onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    height: onReturnBackClick ? "calc(100% - 65px)" : "100%",
                    display: "flex",
                    children: children
                })
            ]
        }));
    }
    return null;
};
/* harmony default export */ var BookingCalendar_DialogBase = (DialogBase);


/***/ }),

/***/ 6904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ StyledScrollbar; },
/* harmony export */   "I2": function() { return /* binding */ StyledDialog; },
/* harmony export */   "UI": function() { return /* binding */ ContactModalLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99611);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30280);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77428);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4595);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23732);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36713);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49889);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75320);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34579);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94801);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98855);
/* harmony import */ var _hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75986);
/* harmony import */ var _hooks_usePhoneViewPortHack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87554);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var StyledDialog = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        display: "flex",
        "& .MuiBackdrop-root": {
            background: theme.custom.DialogContent.background
        },
        "& .MuiDialog-paper": {
            height: "100%",
            margin: 0,
            maxHeight: "none",
            borderRadius: 0,
            maxWidth: "600px",
            width: "100%",
            right: 0,
            position: "fixed"
        },
        "& .MuiDialogContent-root": {
            width: "100%",
            padding: theme.custom.DialogContent.padding,
            overflow: "hidden"
        }
    }, theme.breakpoints.down("sm"), {
        "& .MuiDialog-paper": {
            width: "100%",
            borderRadius: "16px 16px 0px 0px",
            marginTop: "10vh",
            bottom: 0,
            left: 0,
            // fix unexpected vh on IPhone
            height: "calc(var(--vh, 1vh) * 95) !important"
        }
    });
});
var CloseButton = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        padding: "8px",
        minWidth: "auto",
        borderRadius: "50%",
        color: theme.palette.text.black700,
        boxShadow: "0px 0px 7px 0px rgba(0, 0, 0, 0.10)",
        marginRight: "10px",
        width: 35,
        height: 35
    };
});
var StyledScrollbar = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        overflowY: "auto",
        overflowX: "hidden",
        maxHeight: "calc(100vh - 80px)",
        width: "100%"
    }, _defineProperty(_obj, theme.breakpoints.down("md"), theme.custom.SpecialistPage.StyledScrollBar), _defineProperty(_obj, "&::-webkit-scrollbar", {
        width: "6px"
    }), _defineProperty(_obj, "&::-webkit-scrollbar-thumb", {
        backgroundColor: theme.custom.scrollbarThumb.backgroundColor,
        borderRadius: "8px"
    }), _defineProperty(_obj, "&::-webkit-scrollbar-track", {
        backgroundColor: "#d5def9",
        borderRadius: "8px"
    }), _defineProperty(_obj, "&::-webkit-scrollbar-thumb:hover", {
        backgroundColor: "#ccc"
    }), _obj;
});
var StyledDialogContent = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    padding: "24px"
});
var ContactModalLayout = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, heading = param.heading, children = param.children, avatar = param.avatar, name = param.name, rating = param.rating, reviewsTotal = param.reviewsTotal, hideProfileHeader = param.hideProfileHeader, testid = param.testid;
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var profileAvatarAbbreviation = name === null || name === void 0 ? void 0 : name[0].toUpperCase();
    var translate = (0,_hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    (0,_hooks_usePhoneViewPortHack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDialog, {
        open: isOpen,
        onClose: onClose,
        "data-testid": testid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDialogContent, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                container: true,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        mdDown: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                            container: true,
                            item: true,
                            direction: "row",
                            alignItems: "center",
                            pb: "18px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        fontFamily: "Poppins",
                                        fontSize: "23px",
                                        variant: "h3",
                                        color: "text.darkNavy",
                                        fontWeight: 700,
                                        children: heading
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButton, {
                                    variant: "ghost",
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        mdUp: true,
                        children: hideProfileHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            mdUp: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                container: true,
                                mb: theme.custom.SpecialistPage.ProfileModalHeader.mb,
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                wrap: "nowrap",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        mb: "0px",
                                        variant: "h3",
                                        color: "text.darkNavy",
                                        fontSize: theme.custom.SpecialistPage.ProfileHeaderTitle.fontSize,
                                        fontFamily: theme.custom.SpecialistPage.ProfileHeaderTitle.fontFamily,
                                        fontWeight: 700,
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButton, {
                                        variant: "ghost",
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    mb: "32px",
                                    container: true,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    wrap: "nowrap",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                            container: true,
                                            direction: "row",
                                            wrap: "nowrap",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    src: avatar,
                                                    sx: {
                                                        width: 48,
                                                        height: 48,
                                                        mr: "16px",
                                                        borderRadius: "8px"
                                                    },
                                                    children: profileAvatarAbbreviation
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                    container: true,
                                                    direction: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            fontSize: "16px",
                                                            color: "text.primary",
                                                            lineHeight: "24px",
                                                            fontWeight: 600,
                                                            children: name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                            container: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                                    container: true,
                                                                    width: "auto",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                        size: "small",
                                                                        sx: {
                                                                            fontSize: "15px"
                                                                        },
                                                                        value: 1,
                                                                        max: 1,
                                                                        readOnly: true
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                                    item: true,
                                                                    sx: {
                                                                        paddingLeft: "4px !important"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                        variant: "body2",
                                                                        color: "primary.dark",
                                                                        fontWeight: "600",
                                                                        children: rating === null || rating === void 0 ? void 0 : rating.toFixed(2)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                                    item: true,
                                                                    sx: {
                                                                        paddingLeft: "8px !important"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                        variant: "body2",
                                                                        fontWeight: "400",
                                                                        color: "text.black900",
                                                                        children: [
                                                                            reviewsTotal,
                                                                            " ",
                                                                            translate("reviews.reviews").toLowerCase()
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButton, {
                                            variant: "ghost",
                                            onClick: onClose,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    mb: "32px",
                                    variant: "h3",
                                    color: "text.darkNavy",
                                    fontWeight: 700,
                                    children: heading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledScrollbar, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                            pr: "8px",
                            container: true,
                            wrap: "nowrap",
                            direction: "column",
                            item: true,
                            xs: true,
                            children: children
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 87554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePhoneViewPortHack; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ./utils/throttle.ts
var throttle = function(func, ms) {
    var isThrottled = false;
    var savedArgs = null;
    var savedThis = null;
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isThrottled) {
            savedArgs = args;
            savedThis = this;
            return;
        }
        func.apply(this, args);
        isThrottled = true;
        setTimeout(function() {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, ms);
    }
    return wrapper;
};

;// CONCATENATED MODULE: ./hooks/usePhoneViewPortHack.ts


function usePhoneViewPortHack() {
    (0,react.useEffect)(function() {
        var refineVhValue = throttle(function() {
            var vh = window.innerHeight * 0.01;
            // On iPhones, the 100vh unit can behave unexpectedly because the viewport
            // height changes when the browser navigation panel appears or disappears.
            // This will add a --vh property which equals 1% of an actual viewport
            // and could be used in css.
            document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
        }, 100);
        refineVhValue();
        window.addEventListener("resize", refineVhValue);
        return function() {
            window.removeEventListener("resize", refineVhValue);
        };
    }, []);
};


/***/ }),

/***/ 19969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Clear; }
/* harmony export */ });
var Clear = {};




/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ CloseRoundedIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const CloseRoundedIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "21", fill: "none", viewBox: "0 0 20 21" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#fff", d: "M0 0H20V20H0z", transform: "translate(0 .728)", style: { mixBlendMode: 'multiply' } }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", d: "M5.042 5.813l9.916 9.829M14.914 5.77l-9.828 9.916" })));




/***/ })

}]);